import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { SetWorkflowId } from 'apps/check-in-kiosk/src/app/actions/app.actions';
import { Workflow } from '@frontend/shared/workflow/data-access';

@Component({
  selector: 'frontend-workflow-selector',
  templateUrl: './workflow-selector.component.html',
  styleUrls: ['./workflow-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class WorkflowSelectorComponent {
  _link;
  @Input()
  workflows: Workflow[];

  @Input()
  set type(type: string) {
    this._link = `/${type}`;
  }

  constructor(private store: Store<any>) {}

  setWorkflowId(workflowId) {
    this.store.dispatch(new SetWorkflowId({ workflowId }));
  }
}
